<template>
	<div style="listcont">
		<div class="card Pub_flexrowcenter" v-for="(item,index) in listdata" @click="navto(item.id,item.outlink)">
	    <img src="../../static/imgage/dian.png" class="listicon" style="position: absolute;"/>
		<div class="newsmesg">{{item.title}}</div>
		<div class="time">{{item.date}}</div>
		</div>
	</div>
</template>

<script>
	export default({
		data(){
			return{
				
			}
		},
		props:{
			listdata:{
				type:Array,
				default:()=>[]
			}
		},
		methods:{
			navto(id,outlink){
				if(outlink){
				window.open(outlink)
				return;
				}
				this.$router.push({name:"detail",query:{id}})
			}
		}
	})
</script>

<style scoped="scoped">
	.card{
		justify-content: space-between;
		padding-top: 8px;
		padding-bottom: 8px;
		font-size: 14px;
		cursor: pointer;
	}
	.newsmesg{
		padding-left: 20px;
	}
	.newsmesg:hover{
		text-decoration: underline;
		color: #024287;
	}
	.time{
		color: #888888;
	}
</style>



// WEBPACK FOOTER //
// src/components/list.vue